import { ApostleClass, ApostleFilterData } from '@apeiron/apostle'
import useMakeApostle from '@src/deserialize/hook/useMakeApostle'
import useMakeFilter from '@src/deserialize/hook/useMakeFilter'
import * as R from 'ramda'
import { useCallback } from 'react'

const useMakeApostleFilter = (): Hook => {
  const { makeApostleClass } = useMakeApostle()

  const { makeClipFilter, makeSlideFilter } = useMakeFilter<ApostleClass>()

  // private
  const makeApostleClassFromFilter = useCallback(
    (input: any): ApostleClass => {
      return makeApostleClass(R.propOr({}, 'class', input))
    },
    [makeApostleClass]
  )

  // public
  const makeApostleFilter = useCallback(
    (input: any): ApostleFilterData => {
      return {
        class: makeClipFilter(
          R.propOr({}, 'class', input),
          makeApostleClassFromFilter
        ),
        others: R.map(makeSlideFilter, R.propOr([], 'others', input))
      }
    },
    [makeApostleClassFromFilter, makeClipFilter, makeSlideFilter]
  )

  return {
    makeApostleFilter
  }
}

type Hook = {
  makeApostleFilter: (input: any) => ApostleFilterData
}

export default useMakeApostleFilter
